import { render, staticRenderFns } from "./AnimatedClock.vue?vue&type=template&id=22f69734&scoped=true&"
import script from "./AnimatedClock.vue?vue&type=script&lang=js&"
export * from "./AnimatedClock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f69734",
  null
  
)

export default component.exports